export const Filters = {
  NAME: 'name',
  TIER: 'tier'
} as const

// product.categories values come from the backend as `CHF_PRODUCT_CATEGORY_<NAME>`
// (f.e. CHF_PRODUCT_CATEGORY_CHICKEN). Products with none fall into the OTHERS filter.
export const PRODUCT_CATEGORY_FILTER_PREFIX = 'CHF_PRODUCT_CATEGORY_'
export const PRODUCT_CATEGORY_FILTER_OTHERS = `${PRODUCT_CATEGORY_FILTER_PREFIX}OTHERS`

export type CommonFilters = 'all' | `${string}:${string}` // 'all' | `name:${CHF_PRODUCT_CATEGORY_*}` | `tier:${number}`
